export const GET_PROPERTIES_LATLONG = "GET_PROPERTIES_LATLONG";
export const GET_DASHBOARD_STATS = "GET_DASHBOARD_STATS";
export const GET_PROPERTIES_LIST_O = "GET_PROPERTIES_LIST_O";
export const GET_PROPERTIES_LIST_V = "GET_PROPERTIES_LIST_V";
export const GET_PROPERTIES_CARD = "GET_PROPERTIES_CARD";
export const GET_ALLPROPERTIES_STATS = "GET_ALLPROPERTIES_STATS";
export const GET_PROPERTY_ID = 'GET_PROPERTY_ID'
export const DOWNLOAD_DATA = 'DOWNLOAD_DATA'
export const PROPERTY_ID = 'PROPERTY_ID'